import { Helmet } from 'react-helmet-async';
import { twMerge } from 'tailwind-merge';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import ThumbsUpIcon from 'assets/icons/thumbsup.svg?react';
import useUpsale from './useUpsale';
import { TwButton } from 'components/TwButton/TwButton';
import H1 from 'components/H/H1';
import OfferTable from 'components/OfferTable/OfferTable';
import { useTranslation } from 'react-i18next';

export default function Upsale() {
  const { t } = useTranslation();
  const { handleAccept, handleChangeAmount, isLoading, isPending, offer } =
    useUpsale();

  return (
    <>
      <Helmet>
        <title>{t('upsale:html_title')}</title>
      </Helmet>

      <CardWithIcon
        dataTest="upsaleCard-card"
        icon={<ThumbsUpIcon data-test="upsale-icon" />}
        className="rounded-none lg:rounded-lg"
      >
        <div className="flex flex-col items-center gap-3 md:px-6">
          <H1 dataTest="upsaleCard-title" className="lg:w-full">
            {t('upsale:card_title')}
          </H1>
          <p
            data-test="upsaleCard-text-1"
            className="text-center md:w-full md:text-left"
          >
            {t('upsale:card_text1')}
          </p>
          <p
            data-test="upsaleCard-text-2-wrapper"
            className="text-center md:w-full md:text-left"
          >
            {t('upsale:card_text2')}
            <span
              className="text-primary font-semibold"
              data-test="upsaleCard-text-3"
            >
              {t('upsale:card_text3')}
            </span>
            {t('upsale:card_text4')}
          </p>

          <div className="w-full pt-7 pb-8">
            <OfferTable
              totalPrincipal={offer?.totalPrincipal}
              totalRepayableAmount={offer?.totalRepayableAmount}
              extensionFees={offer?.extensionFees[30]}
              interestRate={offer?.interestRate}
              assignedInterest={offer?.assignedInterest}
              firstPaymentDate={offer?.firstPaymentDate}
              futureExtensionFees={offer?.futureExtensionFees?.[0]?.fee}
              loading={isLoading}
            />
          </div>

          <div className="flex gap-4 w-full justify-center lg:justify-start flex-col lg:flex-row">
            <TwButton
              data-test="go-to-change-amount"
              onClick={handleAccept}
              pending={isPending}
              disabled={isPending || isLoading}
            >
              {t('upsale:button_change_amount')}
            </TwButton>
            <TwButton
              data-test="go-calculate-amount"
              onClick={handleChangeAmount}
              pending={isPending}
              disabled={isLoading || isPending}
              className={twMerge(
                'bg-transparent border ',
                isPending
                  ? 'text-primary-foreground border-border'
                  : 'text-primary border-primary',
              )}
            >
              {t('upsale:button')}
            </TwButton>
          </div>
        </div>
      </CardWithIcon>
    </>
  );
}
